import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import type { SeverityBadge } from "./types";

export interface InteractionsSummaryHeaderProps {
  title: string;
  totalCount: number;
  badges: SeverityBadge[];
  /** When set, shows "Drug:", "Allergy:", or "Drug/Allergy:" instead of always "Drug/Allergy:" */
  typeLabel?: "Drug" | "Allergy" | "Drug/Allergy";
}

const InteractionsSummaryHeader: React.FC<InteractionsSummaryHeaderProps> = ({
  title,
  totalCount,
  badges,
  typeLabel = "Drug/Allergy",
}) => (
  <Box
    sx={{
      p: 1.25,
      borderBottom: "1px solid",
      borderColor: "divider",
      bgcolor: "grey.50",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 1.5,
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
      <Typography variant="body2" sx={{ fontWeight: 600, color: "text.primary" }}>
        {title}
      </Typography>
    </Box>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
      <Typography variant="body2" sx={{ fontSize: "0.7rem", fontWeight: 600, color: "text.primary" }}>
        {typeLabel}:
      </Typography>
      <Chip
        label={totalCount}
        color="primary"
        size="small"
        sx={{
          fontWeight: 700,
          fontSize: "0.65rem",
          height: "18px",
          minWidth: "35px",
          color: "white",
        }}
      />
      {badges.map((badge, idx) => (
        <Typography
          key={`${badge.label}-${idx}`}
          variant="body2"
          sx={{
            fontSize: "0.7rem",
            fontWeight: 600,
            color: `${badge.color}.main`,
          }}
        >
          {badge.countText ?? badge.label}
        </Typography>
      ))}
    </Box>
  </Box>
);

export default InteractionsSummaryHeader;
